// We want the customer to nagivate to, and see the name, description and price of the product in the card first. Then the focus should go back to reading order.
var ProductCardOrderEnum;
(function (ProductCardOrderEnum) {
    // All elements that visually should be before the main focus element.
    ProductCardOrderEnum[ProductCardOrderEnum["beforeFirstFocusElement"] = 1] = "beforeFirstFocusElement";
    // All elements that is important for the customer to be focused first.
    ProductCardOrderEnum[ProductCardOrderEnum["firstFocusElement"] = 2] = "firstFocusElement";
    // All elements that visually should be after the main focus element.
    ProductCardOrderEnum[ProductCardOrderEnum["afterFirstFocusElement"] = 3] = "afterFirstFocusElement";
})(ProductCardOrderEnum || (ProductCardOrderEnum = {}));
export default ProductCardOrderEnum;
//# sourceMappingURL=ProductCardOrderEnum.js.map